import { lazy } from 'react'
import { lazyPage } from '../lazy'
import type { VerticalManifest } from '../types'
import en from './i18n/en/overrides/guest.json'
import es from './i18n/es/overrides/guest.json'
import pt from './i18n/pt/overrides/guest.json'

export const diningManifest: VerticalManifest = {
  code: 'dining',
  brand: {
    name: 'Aure Carta',
    tagline: {
      es: 'La carta digital de tu restaurante',
      pt: 'O cardápio digital do seu restaurante',
      en: 'The digital menu for your restaurant',
    },
  },
  landing: lazyPage(() => import('./landing/LandingPage'), 'LandingPage'),
  guestOverrides: { es, pt, en },
  guestDock: lazy(() => import('./guest/TableDock')),
  menuItemAction: lazy(() => import('./guest/ordering/MenuItemAction')),
  staffApp: {
    path: 'equipo',
    views: { phone: '', tv: 'tv', kitchen: 'cocina' },
    Component: lazy(() => import('./staff/StaffApp')),
  },
}
